var raf = typeof requestAnimationFrame === "undefined"
    ? function (callback) { return setTimeout(callback, 17); }
    : requestAnimationFrame;
export var runInFrame = function (no, callback) {
    var cur = 0;
    var canceled = false;
    var loop = function () {
        if (canceled) {
            return;
        }
        if (cur <= no) {
            cur++;
            raf(loop);
            return;
        }
        callback();
    };
    loop();
    return function () { canceled = true; };
};
export default runInFrame;

//# sourceMappingURL=runInFrame.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/runInFrame.js
// module id = 222
// module chunks = 0